<div class="plan-history-modal">
  <!-- Header -->
  <div class="modal-header">
    <h2 class="modal-title">Routines</h2>
    <button mat-icon-button class="close-button" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Tabs -->
  <div class="modal-tabs">
    <div class="tab-group">
      <button
        class="tab-button"
        [class.active]="selectedTab() === 'routines'"
        (click)="onTabChange('routines')"
      >
        {{
          selectedTab() === "routines"
            ? tabTitle
            : "ROUTINES (" + totalPlans() + ")"
        }}
      </button>
      <button
        class="tab-button"
        [class.active]="selectedTab() === 'jobs'"
        (click)="onTabChange('jobs')"
      >
        {{ selectedTab() === "jobs" ? tabTitle : "JOBS (" + totalJobs() + ")" }}
      </button>
    </div>

    <button mat-button class="create-routine-btn" (click)="onCreateRoutine()">
      <mat-icon>add</mat-icon>
      Create Routine
    </button>
  </div>

  <!-- Filters -->
  <div class="filters-section">
    <!-- Search -->
    <mat-form-field appearance="outline" class="search-field">
      <mat-icon matPrefix>search</mat-icon>
      <input
        matInput
        [placeholder]="
          selectedTab() === 'routines' ? 'Routine name...' : 'Job name...'
        "
        [(ngModel)]="searchQuery"
        (input)="onSearch()"
      />
    </mat-form-field>

    <div class="filters-right">
      <!-- Routine (jobs tab only): list was previously always scoped to the first plan -->
      @if (selectedTab() === "jobs" && plans().length > 0) {
        <mat-form-field
          appearance="outline"
          class="filter-field routine-filter-field"
        >
          <mat-label>Routine</mat-label>
          <mat-select
            [value]="selectedPlanId()"
            (selectionChange)="selectedPlanId.set($event.value); onJobsRoutineChange()"
          >
            <mat-option [value]="null">All Routines</mat-option>
            @for (plan of plans(); track plan.planId) {
              <mat-option [value]="plan.planId">{{ plan.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <!-- Status Filter -->
      <mat-form-field appearance="outline" class="filter-field">
        <mat-select
          [(value)]="selectedStatus"
          (selectionChange)="onFilterChange()"
        >
          @for (status of currentStatusOptions; track $index) {
            <mat-option [value]="status">
              {{ status }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Time Filter -->
      <mat-form-field appearance="outline" class="filter-field">
        <mat-select
          [(value)]="selectedTimeFilter"
          (selectionChange)="onFilterChange()"
        >
          @for (time of timeOptions; track $index) {
            <mat-option [value]="time">
              {{ time }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- User Filter -->
      <mat-form-field appearance="outline" class="filter-field user-filter">
        <mat-select
          [(value)]="selectedUser"
          (selectionChange)="onFilterChange()"
        >
          @for (user of userOptions(); track $index) {
            <mat-option [value]="user">
              <div class="user-option">
                {{ user }}
              </div>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <!-- Loading State -->
  @if (loading()) {
    <div class="loading-container">
      <mat-spinner diameter="32"></mat-spinner>
      <span class="loading-text">Loading {{ selectedTab() }}...</span>
    </div>
  }

  <!-- Error State -->
  @if (error() && !loading()) {
    <div class="error-container">
      <div class="error-message">{{ error() }}</div>
      <button
        mat-button
        color="primary"
        (click)="selectedTab() === 'routines' ? loadPlans() : loadJobs()"
      >
        Retry
      </button>
    </div>
  }

  <!-- Pattern Analysis -->
  @if (llmEnabled() && selectedTab() === "jobs" && selectedPlanId()) {
    <app-job-pattern-analysis
      [projectId]="data.projectId"
      [planId]="selectedPlanId()!"
      [routineName]="selectedRoutineName"
    >
    </app-job-pattern-analysis>
  }

  <!-- Table -->
  @if (!loading() && !error()) {
    <div class="table-container">
      <table class="history-table">
        <thead>
          @if (selectedTab() === "routines") {
            <tr>
              <th class="sortable" scope="col">
                Routine name
                <mat-icon class="sort-icon">unfold_more</mat-icon>
              </th>
              <th class="sortable" scope="col">
                Runs as User
                <mat-icon class="sort-icon">unfold_more</mat-icon>
              </th>
              <th class="sortable" scope="col">
                Schedule
                <mat-icon class="sort-icon">unfold_more</mat-icon>
              </th>
              <th class="sortable" scope="col">
                Created at
                <mat-icon class="sort-icon">unfold_more</mat-icon>
              </th>
              <th class="sortable" scope="col">
                Status
                <mat-icon class="sort-icon">unfold_more</mat-icon>
              </th>
              <th scope="col"></th>
            </tr>
          }
          @if (selectedTab() === "jobs") {
            <tr>
              <th class="sortable" scope="col" (click)="onSort('createdAt')">
                Job / Routine name
                <mat-icon class="sort-icon">unfold_more</mat-icon>
              </th>
              <th class="sortable" scope="col">
                Runs as User
                <mat-icon class="sort-icon">unfold_more</mat-icon>
              </th>
              <th class="sortable" scope="col" (click)="onSort('source')">
                Trigger type
                <mat-icon class="sort-icon">unfold_more</mat-icon>
              </th>
              <th class="sortable" scope="col" (click)="onSort('scheduledAt')">
                Started at
                <mat-icon class="sort-icon">unfold_more</mat-icon>
              </th>
              <th class="sortable" scope="col">
                Duration
                <mat-icon class="sort-icon">unfold_more</mat-icon>
              </th>
              <th class="sortable" scope="col" (click)="onSort('status')">
                Status
                <mat-icon class="sort-icon">unfold_more</mat-icon>
              </th>
              <th scope="col"></th>
            </tr>
          }
        </thead>
        <tbody>
          <!-- Use *ngIf (not [hidden] on <tr>) so rows actually render in all browsers -->
          @if (selectedTab() === "routines") {
            @for (plan of filteredPlans(); track trackByItemId($index, plan)) {
              <tr class="table-row">
                <!-- Plan Name -->
                <td class="routine-name-cell">
                  <div class="routine-info">
                    <div class="routine-name">{{ plan.name }}</div>
                    @if (plan.description) {
                      <div class="routine-id">{{ plan.description }}</div>
                    }
                  </div>
                </td>
                <!-- Runs as User -->
                <td class="user-cell">
                  <div class="user-info">
                    <div class="user-avatar">
                      <div class="avatar-fallback">
                        {{ plan.runsAsName.charAt(0) }}
                      </div>
                    </div>
                    <span class="user-name">{{ plan.runsAsName }}</span>
                  </div>
                </td>
                <!-- Schedule -->
                <td class="schedule-cell">
                  <div class="schedule-info">
                    <mat-icon class="schedule-icon">{{
                      plan.schedule === "Manual only" ? "touch_app" : "schedule"
                    }}</mat-icon>
                    <span>{{ plan.schedule }}</span>
                  </div>
                </td>
                <!-- Created At -->
                <td class="created-at-cell">
                  {{ plan.createdAt }}
                </td>
                <!-- Status -->
                <td class="status-cell">
                  <div
                    class="status-badge"
                    [ngClass]="getStatusClass(plan.status)"
                  >
                    <mat-icon class="status-icon">{{
                      getStatusIcon(plan.status)
                    }}</mat-icon>
                    {{ plan.status }}
                  </div>
                </td>
                <!-- Actions -->
                <td class="actions-cell">
                  @if (plan.actions && plan.actions.length > 0) {
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="planActionsMenu"
                      class="actions-button"
                    >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                  }
                  <mat-menu #planActionsMenu="matMenu" class="actions-menu">
                    @for (action of plan.actions; track $index) {
                      <button
                        mat-menu-item
                        (click)="onActionClick(plan, action)"
                      >
                        <mat-icon>{{ getActionIcon(action) }}</mat-icon>
                        <span>{{ action }}</span>
                      </button>
                    }
                  </mat-menu>
                </td>
              </tr>
            }
          }
          @if (selectedTab() === "jobs") {
            @for (job of filteredJobs(); track trackByItemId($index, job)) {
              <tr class="table-row">
                <!-- Job/Plan Name -->
                <td class="routine-name-cell">
                  <div class="routine-info">
                    <div class="routine-name">
                      {{ job.planName }}
                      @if (job.isHeadVersion) {
                        <span
                          class="head-badge"
                          matTooltip="Executed against HEAD (development) version"
                          >HEAD</span
                        >
                      }
                    </div>
                    <div class="routine-id">Job ID: {{ job.jobId }}</div>
                  </div>
                </td>
                <!-- Runs as User -->
                <td class="user-cell">
                  <div class="user-info">
                    <div class="user-avatar">
                      <div class="avatar-fallback">
                        {{ job.runsAsName.charAt(0) }}
                      </div>
                    </div>
                    <span class="user-name">{{ job.runsAsName }}</span>
                  </div>
                </td>
                <!-- Source -->
                <td class="source-cell">
                  <div class="source-info">
                    <mat-icon class="source-icon">{{
                      job.source === "manual"
                        ? "touch_app"
                        : job.source === "scheduled"
                          ? "schedule"
                          : job.source === "triggered"
                            ? "bolt"
                            : "link"
                    }}</mat-icon>
                    <span>{{ job.source }}</span>
                  </div>
                </td>
                <!-- Started At -->
                <td class="started-at-cell">
                  {{ job.startedAt || job.scheduledTime || job.createdAt }}
                </td>
                <!-- Duration -->
                <td class="duration-cell">
                  @if (job.duration) {
                    <span>{{ job.duration }}</span>
                  } @else {
                    -
                  }
                </td>
                <!-- Status -->
                <td class="status-cell">
                  <div
                    class="status-badge"
                    [ngClass]="getStatusClass(job.status)"
                  >
                    <mat-icon class="status-icon">{{
                      getStatusIcon(job.status)
                    }}</mat-icon>
                    {{ job.status }}
                  </div>
                </td>
                <!-- Actions -->
                <td class="actions-cell">
                  @if (job.actions && job.actions.length > 0) {
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="jobActionsMenu"
                      class="actions-button"
                    >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                  }
                  <mat-menu #jobActionsMenu="matMenu" class="actions-menu">
                    @for (action of job.actions; track $index) {
                      <button
                        mat-menu-item
                        (click)="onActionClick(job, action)"
                      >
                        <mat-icon>{{ getActionIcon(action) }}</mat-icon>
                        <span>{{ action }}</span>
                      </button>
                    }
                  </mat-menu>
                </td>
              </tr>
            }
          }
          <!-- Empty State -->
          @if (currentItems.length === 0) {
            <tr class="empty-row">
              <td
                [attr.colspan]="selectedTab() === 'routines' ? 6 : 7"
                class="empty-cell"
              >
                <div class="empty-message">
                  <mat-icon>{{
                    selectedTab() === "routines" ? "event_note" : "work"
                  }}</mat-icon>
                  <p>No {{ selectedTab() }} found</p>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <!-- Pagination -->
  @if (!loading() && !error()) {
    <div class="pagination-section">
      <div class="pagination-info">
        <span>Rows per page:</span>
        <mat-select
          [value]="itemsPerPage()"
          class="rows-per-page"
          (valueChange)="
            itemsPerPage.set($event);
            currentPage.set(1);
            selectedTab() === 'jobs' ? loadJobs() : applyFilters()
          "
        >
          <mat-option [value]="12">12</mat-option>
          <mat-option [value]="25">25</mat-option>
          <mat-option [value]="50">50</mat-option>
        </mat-select>
      </div>
      <div class="pagination-display">
        {{ startItem }}-{{ endItem }} of {{ currentTotal }}
      </div>
      <div class="pagination-controls">
        <button
          mat-icon-button
          (click)="onPreviousPage()"
          [disabled]="currentPage() === 1"
        >
          <mat-icon>chevron_left</mat-icon>
        </button>
        <button
          mat-icon-button
          (click)="onNextPage()"
          [disabled]="currentPage() === totalPages"
        >
          <mat-icon>navigate_next</mat-icon>
        </button>
      </div>
    </div>
  }
</div>
